import React from 'react'
import { NavItemWithBadge } from '@/components/nav/nav-item-with-badge'
import { TASK } from 'icons'

const TaskNavigations = () => {
    return (
        <NavItemWithBadge
            title="Tasks"
            icon={TASK}
            url="/tasks"
            collection="tasks"
            filters={{
                assignee: { _eq: "$CURRENT_USER" },
                status: { _in: ["open", "in_progress"] },
            }}
        />
    )
}

export default TaskNavigations